//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    lastPage: {
      type: Number,
      default: 1,
    },
    pageProp: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    page: {
      get() {
        return JSON.parse(JSON.stringify(this.pageProp));
      },
      set(page) {
        this.$emit('setPage', parseInt(page));
      },
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.lastPage) {
        this.page++;
      } else {
        this.page = 1;
      }
    },
    previousPage() {
      if (this.page - 1 >= 1) {
        this.page--;
      } else {
        this.page = this.lastPage;
      }
    },
  },
};
